
import { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import LoadingScreen from './components/LoadingScreen';
import icon from './assets/icon.png';

function App() {
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [showLoading, setShowLoading] = useState(true);

  useEffect(() => {
    // Set favicon to the app icon
    const setFavicon = () => {
      const existingFavicon = document.querySelector<HTMLLinkElement>("link[rel='icon']");

      if (existingFavicon) {
        existingFavicon.type = 'image/png';
        existingFavicon.href = icon;
      } else {
        const link = document.createElement('link');
        link.rel = 'icon';
        link.type = 'image/png';
        link.href = icon;
        document.head.appendChild(link);
      }
    };

    setFavicon();

    // Check if this is the first visit
    const hasVisited = sessionStorage.getItem('hasVisited');
    
    if (hasVisited) {
      // Skip loading screen for subsequent navigation
      setShowLoading(false);
      setIsInitialLoad(false);
    } else {
      // Show loading screen only on first visit
      sessionStorage.setItem('hasVisited', 'true');
    }
  }, []);

  const handleLoadingComplete = () => {
    setShowLoading(false);
    setTimeout(() => {
      setIsInitialLoad(false);
    }, 100);
  };

  if (isInitialLoad && showLoading) {
    return <LoadingScreen onLoadingComplete={handleLoadingComplete} />;
  }

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
